import React from 'react';
import styled from 'styled-components';

export default function MkbSupport() {

return (
<SupportWrap>
    <nav className="nav">
        <div className="nav-content">Truth Of Beauty Support</div>
    </nav>

    <main className="container flex-mid">
        <div className="title-group">
            <h1>Contact Us</h1>
            <p className="intro">How can we help you today?</p>
        </div>

        <div className="form-card">
            <form
              action="https://docs.google.com/forms/d/e/1FAIpQLScIm2VNXgJ-9YeXmGd0cyCffnwWA_YDN5tfb2eftF18sq3Cvw/formResponse"
              method="POST"
            >
                <div className="input-group">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="entry.672265694"
                      placeholder="email@example.com"
                      required
                    />
                </div>

                <div className="input-group">
                    <label>Message</label>
                    <textarea
                      name="entry.845975852"
                      rows="5"
                      placeholder="Please describe your enquiry"
                      required
                    />
                </div>

                <button type="submit" className="submit-btn">Send Message</button>
                <p className="note">You will be redirected to a Google confirmation page after submission.</p>
            </form>
        </div>
    </main>

    <footer>&copy; 2026 MKB Global Service Private Inc. All rights reserved.</footer>
</SupportWrap>
);
}

const SupportWrap = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f7;
  color: #1d1d1f;

  .nav {
    height: 44px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(20px);
    display: flex;
    align-items: center;
    border-bottom: 1px solid #d2d2d7;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .nav-content {
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
    padding: 0 20px;
    font-weight: 600;
    font-size: 14px;
  }

  .container {
    max-width: 600px;
    margin: 0 auto;
    padding: 60px 20px;
  }

  .title-group {
    text-align: center;
    margin-bottom: 40px;
    
    h1 {
      font-size: 40px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    
    .intro {
      color: #86868b;
      font-size: 19px;
    }
  }

  .form-card {
    background: #fff;
    padding: 40px;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

    .input-group {
      margin-bottom: 25px;
      
      label {
        display: block;
        font-weight: 600;
        margin-bottom: 8px;
        font-size: 14px;
      }

      input, textarea {
        width: 100%;
        padding: 14px;
        border: 1px solid #d2d2d7;
        border-radius: 12px;
        font-size: 16px;
        box-sizing: border-box;
        outline: none;
        background: #fff;
        transition: border-color 0.2s;

        &:focus {
          border-color: #0066cc;
        }
      }

      textarea {
        resize: none;
      }
    }

    .submit-btn {
      width: 100%;
      background: #0066cc;
      color: #fff;
      padding: 16px;
      border: none;
      border-radius: 12px;
      font-size: 17px;
      font-weight: 600;
      cursor: pointer;
      transition: background 0.2s;

      &:hover {
        background: #004499;
      }
    }

    .note {
      font-size: 12px;
      color: #86868b;
      text-align: center;
      margin-top: 15px;
    }
  }

  footer {
    text-align: center;
    padding: 40px 0;
    color: #86868b;
    font-size: 12px;
  }

  .flex-mid {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
